/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Modal, Select, Drawer } from 'antd';
import { DrawerHeader, Header, ModalHeader } from 'datastake-daf/dist/components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import { actions as sclActions } from '../../store/reducers/scl';
import { actions as lirActions } from '../../store/reducers/lir';
import { actions as stkActions } from '../../store/reducers/stakeholder';
import { actions as eventActions } from '../../store/reducers/events';
import { actions as documentActions } from '../../store/reducers/documents';
import { actions as projectActions } from '../../store/reducers/project';
import { actions as spActions } from '../../store/reducers/sp';
import { actions as imActions } from '../../store/reducers/im';
import { actions as sciActions } from '../../store/reducers/sci';
import { actions as bpeActions } from '../../store/reducers/bpe';
import { actions as gmActions } from '../../store/reducers/gm';
import { actions as ampActions } from '../../store/reducers/amp';
import { actions as programsActions } from '../../store/reducers/programs';
import { actions as applicationFormActions } from '../../store/reducers/application-form';
import { actions as mineProfileActions } from '../../store/reducers/mine-profile';
import { actions as linkedSubjectsActions } from '../../store/reducers/linked-subjects';
import { actions as ownershipKycActions } from '../../store/reducers/ownership-kyc';
import { actions as esgAssessmentActions } from '../../store/reducers/esg-assessment';
import Navigation from './navigation';
import Content from './content';
import { Template } from './templates';
import { getNkey, groupSubsections } from './helper';
import { displayMessage } from '../../helpers/Messages';
import { canViewFeatureAction } from '../../constants/roles';
import { isClient } from '../../routes/ModuleRouter';
import ProjectCreate from '../../components/Forms/projects/create';
import Loading from '../../components/Loading';
import { PROJECTS } from '../../helpers/CanAccess';
import Style from './style';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { getPopupContainer } from '../../helpers/popUp';
import { checkPermission } from '../../permissions/usePermissions';
import { renderBreadCrumbs } from '../../helpers/breadCrumbs';
import { namespaceAllPath, dataKey, viewKey, CREATE_DRAWER_WIDTH, renderPageTittle, supportedNamespaces } from '../../helpers/form';
import useStore from '../DataStore/context';
import { EventsService } from '../../services';

export const analysisNamespaces = [
  'kyc',
  'scp',
  'mine-operators',
  'scl',
  'amp',
  'mine-profile',
  'ownership-kyc',
  'programs',
  'esg-assessment',
];

const linkingSubjects = [
  'scl',
  'location',
  'village',
  'stakeholder',
  'scp',
  'mine-operators',
  'lir',
  'initiatives',
  'victims',
  'pictures',
  'documents',
];

const moduleWithLinkingSubjects = ['pme', 'cadd', 'tazama'];

const actions = {
  ...sclActions,
  ...lirActions,
  ...stkActions,
  ...eventActions,
  ...documentActions,
  ...projectActions,
  ...ampActions,
  ...programsActions,
  ...applicationFormActions,
  ...mineProfileActions,
  ...ownershipKycActions,
  ...esgAssessmentActions,
  ...spActions,
  ...imActions,
  ...sciActions,
  ...bpeActions,
  ...gmActions,
  ...linkedSubjectsActions,
};

const emptyArr = [];

const View = ({
  stakeholder: { data: stakeholderData, viewConfig: stakeholderView },
  linkedSubjects: { data: linkedSubjectsData, viewConfig: linkedSubjectsView },
  applicationForm: { data: applicationFormData, viewConfig: applicationFormView },
  amp: { data: ampData, viewConfig: ampView },
  programs: { data: programsData, viewConfig: programsView },
  mineProfile: { data: mineProfileData, viewConfig: mineProfileView },
  ownershipKyc: { data: ownershipKycData, viewConfig: ownershipKycView },
  esgAssessment: { data: esgAssessmentData, viewConfig: esgAssessmentView },
  scl: { data: sclData, viewConfig: sclView },
  events: { data: eventData, viewConfig: eventView },
  documents: { data: documentData, viewConfig: documentView },
  lir: { data: lirData, viewConfig: lirView },
  project: { data: projectData, viewConfig: projectView },
  sp: { data: spData, viewConfig: spView },
  im: { data: imData, viewConfig: imView },
  sci: { data: sciData, viewConfig: sciView },
  bpe: { data: bpeData, viewConfig: bpeView },
  gm: { data: gmData, viewConfig: gmView },
  authentication: { user, selectedProject: selProject },
  stakeholderDataGet,
  ampDataGet,
  programsDataGet,
  applicationFormDataGet,
  applicationFormSubmitForm,
  ownershipKycSubmitForm,
  mineProfileSubmitForm,
  mineProfileDataGet,
  linkedSubjectsDataGet,
  ownershipKycDataGet,
  esgAssessmentDataGet,
  ampApproveApplication,
  SCLDataGet,
  eventsDataGet,
  documentsDataGet,
  lirDataGet,
  spDataGet,
  imDataGet,
  sciDataGet,
  bpeDataGet,
  gmDataGet,
  ProjectDataGet,
  ProjectRemove,
  eventsRemove,
  eventSubmitForm,
  documentsRemove,
  sclRemove,
  stakeholderRemove,
  ampRemove,
  ampDeclineApplication,
  programsRemove,
  applicationFormRemove,
  mineProfileRemove,
  ownershipKycRemove,
  esgAssessmentRemove,
  lirRemove,
  mode = 'app',
  ampEditApplication,
}) => {
  const [modal, contextHolder] = Modal.useModal();
  const selectedProject = selProject;
  const push = useNavigate();
  const allData = { stakeholderData, ampData, programsData, sclData, eventData, lirData, projectData, spData, imData, sciData, bpeData, gmData, mineProfileData, documentData, ownershipKycData, esgAssessmentData, applicationFormData, linkedSubjectsData };
  const allView = { stakeholderView, ampView, programsView, sclView, eventView, lirView, projectView, spView, imView, sciView, bpeView, gmView, mineProfileView, documentView, ownershipKycView, esgAssessmentView, applicationFormView, linkedSubjectsView };
  // const { namespace, id, group, subsection, subgroup } = useParams();
  const params = useParams();
  const [namespace, setNamespace] = useState(params.namespace);
  const [id, setId] = useState(params.id);
  const [group, setGroup] = useState(params.group);
  const [subsection, setSubSection] = useState(params.subsection);
  const { setFetched: setDataStoreFetched } = useStore();
  // const [subgroup, setSubGroup] = useState(params.subgroup);

  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const [form, setForm] = useState({});
  const [data, setData] = useState({});
  const [groups, setGroups] = useState({});
  const [linkingForms, setLinkingForms] = useState({});
  const [viewConfig, setViewConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [deletionVisible, setDeletionVisible] = useState(false);
  const [deletionReason, setDeletionReason] = useState(null);
  const [sProject, setSProject] = useState(null);
  const [headerTags, setHeaderTags] = useState([]);
  const [inviteClient, setInviteClient] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [language, setLanguage] = useState(user.language);
  const [, module] = mode === 'proxy' ?
    pathname.split(/\/proxy\/(pme|cadd|tif|tazama)\/view/)
    : pathname.split(/\/app\/(pme|cadd|tif|tazama)\/view/);
  const [extraPageActions, setExtraPageActions] = useState([]);
  const [pageActions, setPageActions] = useState([]);
  const [versionsDatapoints, setVersionsDatapoints] = useState({});
  // const excludedKeys = ['id', 'userId', 'position', 'authorId', 'label', 'outputLabel', 'icon', 'sectionLabel', 'formDescription', 'introText', 'alertConf', 'showFormIf', 'excludeFromEdit'];

  const fetchVersions = async () => {
    try {
      switch (namespace) {
        case 'incidents':
        case 'corrective-actions':
        case 'testimonials':
          const { data } = await EventsService.getVersioning(id);
          setVersionsDatapoints(data);
          break;
        default:
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVersions();
  }, []);

  const isSupportedNamespaces = useMemo(() => ({
    'application-form': () => id === 'user' ? !['assessment', 'preAssessed', 'review'].includes(data?.status || data?.ampStatus) : true,
  }), [data, id]);

  const isSupported = typeof isSupportedNamespaces[namespace] === 'function'
    ? isSupportedNamespaces[namespace]() && (supportedNamespaces[module] && supportedNamespaces[module].includes(namespace))
    : (supportedNamespaces[module] && supportedNamespaces[module].includes(namespace));
  const queryParam = new URLSearchParams(search);
  const version = queryParam.get('version') || undefined;
  let sourceId = queryParam.get('sourceId') || undefined;

  if (!sourceId && localStorage.getItem('source')) {
    sourceId = localStorage.getItem('source');
  }

  useEffect(() => {
    if (data) {
      if (typeof isSupportedNamespaces[namespace] === 'function') {
        if (!isSupportedNamespaces[namespace]()) {
          push(`/app/${module}`);
        }
      }
    }
  }, [data, namespace]);

  const getEditLink = (srcId) => {
    const r = new RegExp(`\/view\/`);
    const [previous, extra] = pathname.split(r);

    if (srcId) {
      push(`${previous}/edit/${extra}?sourceId=${srcId}`);
      return;
    }

    if (search) {
      push(`${previous}/edit/${extra}${search}`);
    } else {
      push(`${previous}/edit/${extra}`);
    }
  }

  const match = useMemo(() => ({
    params,
    path: pathname,
  }), [params, pathname]);

  const getRiskEditLink = (category, subCategory) => {
    const url = `/${mode}/${module}/edit/${namespace}/${id}/risk/${category}/${subCategory}`;
    push(url);
  }

  const isProjectApproved = () => {
    return data &&
      data.id &&
      user &&
      user.projects &&
      Array.isArray(user.projects) &&
      user.projects.filter(p => p.id === data.id && p.status === 'approved').length === 1 ? true : false;
  }
  const isUserData = () => {
    return data && data.authorId && (user?.company?.id === data.authorId)
  }

  const canEditAction = {
    stakeholder: () => {
      if (module === 'tazama') {
        return false;
      }

      return checkPermission({ permission: 'stakeholders.canEdit', permissions: user?.role?.permissions }) && isUserData()
    },
    scp: () => checkPermission({ permission: 'stakeholders.SCA.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    // TO-DO add permissions
    'mine-operators': () => true && isUserData(),
    amp: () => data.ampStatus !== 'declined' && checkPermission({ permission: 'amp.canEdit', permissions: user?.role?.permissions }) && isUserData(),
    programs: () => checkPermission({ permission: 'programs.canEdit', permissions: user?.role?.permissions }) && isUserData(),
    'application-form': () => {
      return !['applied'].includes(data.status || data.ampStatus) && checkPermission({ permission: 'applicationForm.canEdit', permissions: user?.role?.permissions });
    },
    'mine-profile': () => checkPermission({ permission: 'mineProfile.canEdit', permissions: user?.role?.permissions }) && isUserData() && data.mineProfileStatus !== 'approved',
    'ownership-kyc': () => checkPermission({ permission: 'KYC.canEdit', permissions: user?.role?.permissions }) && isUserData() && data.kycStatus !== 'approved',
    'esg-assessment': () => checkPermission({ permission: 'amp.canEdit', permissions: user?.role?.permissions }),
    location: () => {
      if (module === 'tazama') {
        return false;
      }

      return checkPermission({ permission: 'locations.canEdit', permissions: user?.role?.permissions }) && isUserData()
    },
    scl: () => checkPermission({ permission: 'locations.mineSites.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    village: () => checkPermission({ permission: 'locations.villages.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    project: () => checkPermission({ permission: 'projects.canEdit', permissions: user?.role?.permissions }) &&
      !user?.company?.id &&
      isProjectApproved() && canViewFeatureAction({ user, module, feature: 'projects', action: 'edit' }) && (
        isClient(user) || (data && data.authorId && data.authorId === user?.company?.id)
      ),
    event: () => checkPermission({ permission: 'events.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    incidents: () => checkPermission({ permission: 'events.incidents.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    initiatives: () => isUserData(),
    pictures: () => false,
    victims: () => false,
    'corrective-actions': () => checkPermission({ permission: 'events.correctiveActions.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    testimonials: () => checkPermission({ permission: 'events.correctiveActions.canEdit', permissions: user?.role?.permissions })
    && isUserData(),
    documents: () => {
      if (module === 'tazama') {
        return false;
      }

      return checkPermission({ permission: 'documents.canEdit', permissions: user?.role?.permissions }) && isUserData()
    },
    lir: () => checkPermission({ permission: 'stakeholders.LIR.canEdit', permissions: user?.role?.permissions })
      && data && data.authorId && (user?.company?.id === data.authorId),
    kyc: () => checkPermission({ permission: 'myOrganisation.KYC.canEdit', permissions: user?.role?.permissions })
      && (isUserData() || !data.authorId),
    sp: () => checkPermission({ permission: 'myOrganisation.DDSystems.SCP.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    im: () => checkPermission({ permission: 'myOrganisation.DDSystems.internalManagement.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    sci: () => checkPermission({ permission: 'myOrganisation.DDSystems.SCP.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    bpe: () => checkPermission({ permission: 'myOrganisation.DDSystems.supplierEngagement.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    gm: () => checkPermission({ permission: 'myOrganisation.DDSystems.grievanceMechanism.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
  }

  const canDeleteAction = {
    stakeholder: module === 'tazama' ? false : checkPermission({ permission: 'stakeholders.canDelete', permissions: user?.role?.permissions }),
    scp: checkPermission({ permission: 'stakeholders.SCA.canDelete', permissions: user?.role?.permissions }),
    // TO-DO add permissions
    'mine-operators': true,
    amp: true,
    programs: false,
    'application-form': false,
    'mine-profile': true,
    'ownership-kyc': true,
    'esg-assessment': true,
    location: module === 'tazama' ? false : checkPermission({ permission: 'locations.canDelete', permissions: user?.role?.permissions }),
    scl: checkPermission({ permission: 'locations.mineSites.canDelete', permissions: user?.role?.permissions }),
    project: checkPermission({ permission: 'projects.canDelete', permissions: user?.role?.permissions }),
    event: checkPermission({ permission: 'events.canDelete', permissions: user?.role?.permissions }),
    'corrective-actions': module === 'tazama' ? false : checkPermission({ permission: 'events.correctiveActions.canDelete', permissions: user?.role?.permissions }),
    testimonials: module === 'tazama' ? false : checkPermission({ permission: 'events.correctiveActions.canDelete', permissions: user?.role?.permissions }),
    incidents: module === 'tazama' ? false : checkPermission({ permission: 'events.incidents.canDelete', permissions: user?.role?.permissions }),
    initiatives: false,
    pictures: false,
    victims: false,
    documents: module === 'tazama' ? false : checkPermission({ permission: 'documents.canDelete', permissions: user?.role?.permissions }),
    lir: checkPermission({ permission: 'stakeholders.LIR.canDelete', permissions: user?.role?.permissions }),
    village: checkPermission({ permission: 'locations.villages.canDelete', permissions: user?.role?.permissions }),
  }

  const canInviteCustomer = !user?.company?.id
    && namespace === 'project'
    && !isClient(user)
    && isProjectApproved()
    && canViewFeatureAction({
      user,
      module: 'pme',
      feature: 'projects',
      action: 'inviteCustomer'
    });

  const riskActions = () => {
    const actions = [];
    const tags = [];

    const url = window.location.href;

    const group = url.split('/risk/');
    if (group && group[1]) {
      const subgroups = group[1].split('/');
      if (subgroups) {
        const category = subgroups[0];
        const subCategory = subgroups[1];

        tags.push({
          label: id,
        });

        if (canEditAction[namespace]() && selectedProject === PROJECTS.myData) {
          if (subCategory && subCategory.length) {
            actions.push({
              type: "primary",
              onClick: () => getRiskEditLink(category, subCategory),
              label: t('Edit'),
            })
          }
        }
      }
    }

    return { actions, tags };
  };

  const groupForm = useMemo(() => {
    const gF = form[group] || {};
    if (subsection) {
      const sectionForms = groupSubsections(gF);
      if (sectionForms[subsection]) {
        return sectionForms[subsection];
      }
    }
    return gF;
  }, [form, group, subsection]);

  const noDeleteButtonOnNamespaces = ['kyc', 'sp', 'im', 'sci', 'bpe', 'gm'];

  // params
  useEffect(() => {
    if ((id && params.id !== id) || (namespace && namespace !== params.namespace)) {
      setGroup(undefined);
      setSubSection(undefined);
      // setSubGroup(undefined);
    } else {
      setGroup(params.group);
      setSubSection(params.subsection);
      // setSubGroup(params.subgroup);
    }
    setNamespace(params.namespace);
    setId(params.id);
  }, [params]);

  const goToAssessmentScp = (id, sourceId) => {
    let str = `/${mode}/${module}/analysis/scp/${id}`;
    if (sourceId && sourceId !== 'overview') {
      str += `/${sourceId}`;
    }
    push(str);
  };

  const goToAssessmentMineOperators = (id, sourceId) => {
    let str = `/${mode}/${module}/analysis/mine-operators/${id}`;
    if (sourceId && sourceId !== 'overview') {
      str += `/${sourceId}`;
    }
    push(str);
  };

  const goToAssessmentScl = (id, sourceId) => {
    let str = `/${mode}/${module}/analysis/scl/${id}`;
    if (sourceId && sourceId !== 'overview') {
      str += `/${sourceId}`;
    }
    push(str);
  };

  const goToAssessmentKyc = () => {
    push(`/${mode}/${module}/analysis/kyc`);
  };

  const isAnalysis = useMemo(() => {
    const showKyc = namespace === 'kyc' ? module === 'cadd' : true;
    return analysisNamespaces.includes(namespace) && showKyc
  }, [namespace]);

  useEffect(() => {
    const tags = [];
    const actions = [];
    const extraActions = [];

    const addAppFormSubmit = () => {
      actions.push({
        label: t('Submit'),
        type: 'primary',
        disabled: (data.applicationFormStatus === 'declined' || data.ampStatus === 'declined')
          ? !data.dataReadyToSubmit : data?.ampCompletionPercentage !== 100,
        onClick: () => modal.confirm({
          title: t('Are you sure you want to submit?'),
          content: t('You will not be able to edit further.'),
          okText: t('Yes'),
          cancelText: t('No'),
          onOk: () => {
            applicationFormSubmitForm({ ...data, view: namespace }, setLoading, setData);
          },
          onCancel: () => { },
        }),
      })
    }

    if (isSupported) {
      if (groupForm.template === 'risk') {
        const riskConf = riskActions();
        setHeaderTags(riskConf.tags);
        setPageActions(riskConf.actions);
        return;
      }

      if (canEditAction[namespace]() && selectedProject === PROJECTS.myData && !isAnalysis) {
        // Application Form, where user is AMP
        if (namespace === 'application-form' && data.ampStatus === 'registered') {
          addAppFormSubmit();
          actions.push({ label: t('Edit'), onClick: () => getEditLink() });
        } else {
          const addEdit = () => {
            actions.push({ label: t('Edit'), type: 'primary', onClick: () => getEditLink() });
          };

          // App Form
          if (namespace === 'application-form') {
            if (data.ampStatus !== 'application') {
              addEdit();
            }
          } else if (['incidents', 'corrective-actions', 'testimonials'].includes(namespace) && module === 'tazama') { // tazama incidents, correctiveActions
            // TODO: change variable names
            const disabled = data.published || data.percentageCompletion !== 100;

            actions.push({
              label: t('Submit'),
              type: 'primary',
              disabled,
              tooltip: disabled ? t('Complete form to submit information') : undefined,
              onClick: () => modal.confirm({
                title: t('Are you sure you want to submit?'),
                content: t('This information will be stored and made available to your designated partners.'),
                okText: t('Yes'),
                cancelText: t('No'),
                onOk: () => {
                  eventSubmitForm({ ...data, view: 'scoping', module }, setLoading, () => {
                    fetchVersions();
                  });
                },
                onCancel: () => { },
              }),
            })
            actions.push({ label: t('Edit'), onClick: () => getEditLink() });
          } else {
            addEdit();
          }
        }

        if (mode !== 'proxy') {
          // TO-DO
          if (data && data.id && !noDeleteButtonOnNamespaces.includes(namespace)) {
            extraActions.push({
              label: t('Delete'),
              type: 'danger',
              disabled: !canDeleteAction[namespace],
              onClick: () => setDeletionVisible(true),
            })
          }
        }
        if (canInviteCustomer) {
          extraActions.push({
            label: t('Invite Client'),
            onClick: () => setInviteClient(true),
          })
        }
      }

      // if (id !== 'user') {
      // tags.push({ label: id });
      // }

      if (canEditAction[namespace]() && selectedProject === PROJECTS.myData && isAnalysis) {
        const _addEdit = (isPrimary = true) => {
          if (['mine-profile', 'ownership-kyc'].includes(namespace) && (['assessment', 'registered', 'review'].includes(data.ampStatus))) {
            if (
              (namespace === 'mine-profile' && ['approved', 'review'].includes(data.mineProfileStatus)) ||
              (namespace === 'ownership-kyc' && ['approved', 'review'].includes(data.kycStatus))
            ) {
              // DO NOTHING
            } else {
              const getIsDisabled = () => {
                if (data.ampStatus === 'declined') {
                  return !data.dataReadyToSubmit;
                }

                if (namespace === 'mine-profile') {
                  if (data.mineProfileStatus === 'declined') {
                    return !data.mineProfileReadyToSubmit;
                  }

                  return data?.mineProfileCompletionPercentage !== 100;
                }

                if (namespace === 'ownership-kyc') {
                  if (data.kycStatus === 'declined') {
                    return !data.kycReadyToSubmit;
                  }

                  return data?.kycCompletionPercentage !== 100;
                }

                if (namespace === 'amp') {
                  if (data.ampStatus === 'declined') {
                    return !data.dataReadyToSubmit;
                  }
                }

                return false;
              };
              actions.push({
                label: t('Submit'),
                type: 'primary',
                disabled: getIsDisabled(),
                onClick: () => modal.confirm({
                  title: t('Are you sure you want to submit?'),
                  content: t('You will not be able to edit further.'),
                  okText: t('Yes'),
                  cancelText: t('No'),
                  onOk: () => {
                    switch (namespace) {
                      case 'mine-profile':
                        mineProfileSubmitForm(data, setLoading, setData);
                        break;
                      case 'ownership-kyc':
                        ownershipKycSubmitForm(data, setLoading, setData);
                        break;
                      default:
                    }
                  },
                  onCancel: () => { },
                }),
              })

              actions.push({
                label: t('Edit'),
                onClick: () => getEditLink(),
              })
            }
          } else {
            // if (namespace === 'mine-profile' && data.mineProfileStatus !== 'review') {
            //   actions.push({
            //     label: t('Edit'),
            //     type: data.ampStatus === 'application' ? 'default' : 'primary',
            //     onClick: () => getEditLink(),
            //   })
            // } else if (namespace === 'ownership-kyc' && data.kycStatus !== 'review') {
            //   actions.push({
            //     label: t('Edit'),
            //     type: data.ampStatus === 'application' ? 'default' : 'primary',
            //     onClick: () => getEditLink(),
            //   })
            // } else {
            //   if (namespace === 'amp' && data.applicationFormStatus !== 'approved') {
            //     actions.push({
            //       label: t('Edit'),
            //       type: isPrimary ? 'primary' : 'default',
            //       onClick: () => getEditLink(),
            //     })
            //   } else if (namespace !== 'amp') {
            //     actions.push({
            //       label: t('Edit'),
            //       type: isPrimary ? 'primary' : 'default',
            //       onClick: () => getEditLink(),
            //     })
            //   }
            // }

            if (namespace === 'programs') {
              actions.push({
                label: t('Edit'),
                type: isPrimary ? 'primary' : 'default',
                onClick: () => getEditLink(),
              })
            }
          }
        }

        if (namespace === 'amp') {
          if (data.ampStatus === 'registered' && isUserData()) {
            addAppFormSubmit();
            _addEdit(false);
          } else if (data.ampStatus !== 'application' || isUserData()) {
            _addEdit(true);
          }
        } else {
          _addEdit(true);
        }
      }

      if (isAnalysis) {
        if (['amp', 'mine-profile', 'ownership-kyc', 'esg-assessment'].includes(namespace) && module === 'tif') {
          if (
            (namespace === 'amp' && ['application'].includes(data.ampStatus)) ||
            (namespace === 'mine-profile' && data.mineProfileStatus === 'review' && user?.appRole?.code === 'AppAdmin') ||
            (namespace === 'ownership-kyc' && data.kycStatus === 'review' && user?.appRole?.code === 'AppAdmin')
          ) { // tif review buttons
            if (namespace === 'amp' && !data.applicationFormStatus) {
              addAppFormSubmit();
            } else {
              extraActions.push(...[
                {
                  label: t('Decline'),
                  value: 'decline',
                  onClick: () => {
                    Modal.confirm({
                      title: t('Are you sure you want to decline?'),
                      content: t(
                        namespace === 'amp' ? 'This AMP will be notified and unable to access other information compilation forms.'
                          : namespace === 'mine-profile'
                            ? 'The AMP will be notified and have the ability to submit a new Mine Profile Form.'
                            : 'The AMP will be notified and have the ability to submit a new Ownership & KYC Form.'
                      ),
                      onOk: () => {
                        setLoading(true);
                        ampDeclineApplication({ ...data, module, view: namespace }, () => {
                          setLoading(false)
                        })
                      },
                      okText: t('Yes'),
                      noText: t('No'),
                    });
                  },
                  visible: namespace === 'amp' ?
                    !(isUserData() && user?.appRole?.code === 'AppAdmin' && data.applicationFormStatus === 'review')
                    : true,
                  disabled: !isUserData() ? data.tifAmpVersionStatus !== 'application' : false,
                },
              ].filter((v) => v.visible));

              actions.push({
                label: t('Approve'),
                disabled: !isUserData() ? data.tifAmpVersionStatus ? data.tifAmpVersionStatus !== 'application' : data.tifAmpVersionStatus : false,
                type: 'primary',
                onClick: () => {
                  Modal.confirm({
                    title: t('Are you sure you want to approve?'),
                    content: t("By proceeding, you declare that your information matches the original source's data exactly."),
                    onOk: () => {
                      setLoading(true);
                      setDataStoreFetched(true);
                      ampApproveApplication({ ...data, module, view: namespace }, () => {
                        setLoading(false)
                      })
                    },
                    okText: t('Approve'),
                    noText: t('Cancel'),
                  });
                },
              })
            }

            if (!isUserData()) {
              actions.push({
                label: t('Edit'),
                onClick: () => {
                  Modal.confirm({
                    title: t('Upon editing, you will create your own information copy'),
                    content: t('You have the option to build upon information from your source or start from an empty form.'),
                    closable: true,
                    onOk: () => {
                      setLoading(true);
                      ampEditApplication({ ...data, module, view: namespace, tifAmpStatus: 'notEmpty' }, (data) => {
                        setLoading(false)
                        if (data) {
                          getEditLink(data?.authorId);
                        }
                      })
                    },
                    onCancel: (...props) => {
                      if (props.length) {
                        return;
                      }

                      setLoading(true);
                      ampEditApplication({ ...data, module, view: namespace, tifAmpStatus: 'empty' }, (data) => {
                        setLoading(false)
                        if (data) {
                          getEditLink(data?.authorId);
                        }
                      })
                    },
                    cancelText: t('Empty form'),
                    okText: t('Use existing data'),
                  });
                }
              })
            } else if (['ownership-kyc', 'mine-profile', 'amp'].includes(namespace)) {
              actions.push({
                label: t('Edit'),
                onClick: () => getEditLink(),
              })
            }

            setHeaderTags(tags);
            setPageActions(actions);
            setExtraPageActions(extraActions)
            return;
          }

          if (
            (namespace === 'amp' && data.ampStatus === 'application')
          ) { // tif review buttons
            if (!isUserData()) {
              actions.push({
                label: t('Edit'),
                onClick: () => {
                  Modal.confirm({
                    title: t('Upon editing, you will create your own information copy'),
                    content: t('You have the option to build upon information from your source or start from an empty form.'),
                    onOk: () => {
                      setLoading(true);
                      ampEditApplication({ ...data, module, view: namespace, tifAmpStatus: 'notEmpty' }, (data) => {
                        setLoading(false)
                        if (data) {
                          getEditLink(data?.authorId);
                        }
                      })
                    },
                    onCancel: (...props) => {
                      if (props.length) {
                        return;
                      }

                      setLoading(true);
                      ampEditApplication({ ...data, module, view: namespace, tifAmpStatus: 'empty' }, (data) => {
                        setLoading(false)
                        if (data) {
                          getEditLink(data?.authorId);
                        }
                      })
                    },
                    cancelText: t('Empty form'),
                    okText: t('Use existing data'),
                    closable: true,
                  });
                }
              })
            }
          } else if (data.ampStatus !== 'declined') {
            extraActions.push(...[
              {
                label: t('Summary'),
                onClick: () => {
                  if (sourceId) {
                    push('/app/tif/analysis/amp/' + data.datastakeId + '/' + sourceId)
                  } else {
                    push('/app/tif/analysis/amp/' + data.datastakeId)
                  }
                },
                visible: id !== 'user',
                disabled: data.ampStatus === 'application',
                key: "view",
              },
              {
                visible: id !== 'user',
                label: t('Application Form'),
                className: namespace === 'amp' ? 'primary' : '',
                key: "edit",
                onClick: () => {
                  if (namespace !== 'amp') {
                    if (id === 'user') {
                      push('/app/tif/view/amp/user')
                    } else {
                      if (sourceId) {
                        push('/app/tif/view/amp/' + data.datastakeId + '/?sourceId=' + sourceId)
                      } else {
                        push('/app/tif/view/amp/' + data.datastakeId)
                      }
                    }
                  }
                },
              },
              {
                label: t('Mine Profile'),
                key: 'mineProfile',
                visible: true,
                disabled: data.ampStatus === 'application' ||
                  (!isUserData() && data?.ampStatus === 'assessment' && !data.mineProfileStatus && data.sources.includes('AMP')),
                className: namespace === 'mine-profile' ? 'primary' : '',
                onClick: () => {
                  if (namespace !== 'mine-profile') {
                    if (id === 'user') {
                      push(`/app/tif/view/mine-profile/user`);
                    } else {
                      if (sourceId) {
                        push(`/app/tif/view/mine-profile/${data.datastakeId}?sourceId=${sourceId}`);
                      } else {
                        push(`/app/tif/view/mine-profile/${data.datastakeId}`);
                      }
                    }
                  }
                },
              },
              {
                key: 'ownership&kyc',
                label: t('Ownership & KYC'),
                visible: true,
                disabled: data.ampStatus === 'application' ||
                  (!isUserData() && data?.ampStatus === 'assessment' && !data.kycStatus && data.sources.includes('AMP')),
                className: namespace === 'ownership-kyc' ? 'primary' : '',
                onClick: () => {
                  if (namespace !== 'ownership-kyc') {
                    if (id === 'user') {
                      push(`/app/${module}/view/ownership-kyc/user`)
                    } else {
                      if (sourceId) {
                        push(`/app/tif/view/ownership-kyc/${data.datastakeId}?sourceId=${sourceId}`);
                      } else {
                        push(`/app/tif/view/ownership-kyc/${data.datastakeId}`);
                      }
                    }
                  }
                },
              },
              {
                visible: id !== 'user',
                key: 'productionReports',
                label: t('Production Reports'),
                disabled: true,
              },
              {
                key: "productionReports",
                onClick: () => { },
                label: t('Equipments & Inventory'),
                disabled: true,
              },
              {
                visible: id !== 'user',
                key: 'ESGAssessment',
                disabled: true,
                // disabled: data.ampStatus === 'application',
                label: t('ESG Assessment'),
                className: namespace === 'esg-assessment' ? 'primary' : '',
                onClick: () => {
                  if (namespace !== 'esg-assessment') {
                    push(`/app/${module}/view/esg-assessment/${data.datastakeId}`)
                  }
                },
              },
            ].filter((v) => v.visible));
          }
        } else if (namespace === 'programs' && module === 'tif') {
          actions.push({
            label: t('Analysis'),
            onClick: () => {
              push(`/app/${module}/analysis/programs/${data.datastakeId}`);
            },
          });
        } else {
          actions.push({
            label: t('Analysis'),
            onClick: () => {
              if (namespace === 'kyc') {
                goToAssessmentKyc()
              } else if (namespace === 'scp') {
                goToAssessmentScp(data.datastakeId, sourceId);
              } else if (namespace === 'mine-operators') {
                goToAssessmentMineOperators(data.datastakeId, sourceId);
              } else if (namespace === 'scl') {
                goToAssessmentScl(data.datastakeId, sourceId);
              }
            },
          });
        }
      }

      setHeaderTags(tags);
      setPageActions(actions);
      setExtraPageActions(extraActions)
    }
  }, [namespace, data, pathname, group]);

  const namespaceRemove = {
    stakeholder: stakeholderRemove,
    amp: ampRemove,
    programs: programsRemove,
    'application-form': applicationFormRemove,
    'mine-profile': mineProfileRemove,
    'ownership-kyc': ownershipKycRemove,
    'esg-assessment': esgAssessmentRemove,
    scp: stakeholderRemove,
    'mine-operators': stakeholderRemove,
    location: sclRemove,
    scl: sclRemove,
    village: sclRemove,
    event: eventsRemove,
    incidents: eventsRemove,
    initiatives: () => { },
    pictures: () => { },
    victims: () => { },
    'corrective-actions': eventsRemove,
    testimonials: eventsRemove,
    documents: documentsRemove,
    lir: lirRemove,
    project: ProjectRemove,
  };

  const isDueDiligence = () => {
    return ['kyc', 'sp', 'im', 'sci', 'bpe', 'gm'].includes(namespace) && selectedProject !== PROJECTS.myData && id !== 'user';
  }
  const dueDiligence = (payload) => {
    if (isDueDiligence()) {
      payload.datastakeId = id;
      // payload.view = 'due-diligence';
    }
    return payload;
  }

  const namespaceGet = {
    'esg-assessment': () => esgAssessmentDataGet({
      namespace: 'esg-assessment',
      module,
      view: namespace.toLowerCase(),
      datastakeId: id,
      version,
      sourceId,
    }),
    'ownership-kyc': () => ownershipKycDataGet({
      namespace: 'ownership-kyc',
      module,
      view: namespace.toLowerCase(),
      datastakeId: id,
      version,
      sourceId,
    }),
    'mine-profile': () => mineProfileDataGet({
      namespace: 'mine-profile',
      module,
      view: namespace.toLowerCase(),
      datastakeId: id,
      version,
      sourceId,
    }),
    'application-form': () => applicationFormDataGet({
      namespace: 'amp',
      module,
      view: namespace.toLowerCase(),
      datastakeId: id,
      version,
      sourceId,
      scope: 'amp'
    }),
    programs: () => programsDataGet({
      namespace: 'programs',
      module,
      view: namespace.toLowerCase(),
      datastakeId: id,
      version,
      sourceId,
    }),
    amp: () => ampDataGet({
      namespace: 'amp',
      module,
      view: namespace.toLowerCase(),
      datastakeId: id,
      version,
      sourceId,
      scope: 'amp'
    }),
    stakeholder: () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      version,
      sourceId,
    }),
    scp: () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      version,
      sourceId,
    }),
    'mine-operators': () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      version,
      sourceId,
    }),
    kyc: () => stakeholderDataGet(dueDiligence({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      version,
      sourceId,
    })),
    location: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      version,
      sourceId,
    }),
    scl: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      version,
      sourceId,
    }),
    village: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      version,
      sourceId,
    }),
    event: () => {
      eventsDataGet({
        namespace: 'Events',
        scope: namespace,
        module,
        view: 'scoping',
        datastakeId: id,
        version,
        sourceId,
      })
    },
    victims: () => linkedSubjectsDataGet({
      namespace: 'victims',
      module,
      scope: namespace,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    pictures: () => linkedSubjectsDataGet({
      namespace: 'pictures',
      module,
      scope: namespace,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    initiatives: () => linkedSubjectsDataGet({
      namespace: 'initiatives',
      module,
      scope: namespace,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    incidents: () => eventsDataGet({
      namespace: 'Events',
      module,
      scope: namespace,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    'corrective-actions': () => eventsDataGet({
      namespace: 'Events',
      scope: namespace,
      module,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    testimonials: () => eventsDataGet({
      namespace: 'Events',
      module,
      scope: namespace,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    documents: () => documentsDataGet({
      namespace: 'Documents',
      module,
      view: 'scoping',
      datastakeId: id,
      version,
      sourceId,
    }),
    lir: () => lirDataGet({
      namespace: 'Lir',
      module,
      view: 'scoping',
      lirId: id,
      version,
      sourceId,
    }),
    project: () => ProjectDataGet({
      namespace: 'PMEProject',
      module,
      view: 'project',
      projectId: id,
      version,
      sourceId,
    }),
    sp: () => spDataGet(dueDiligence({
      namespace: 'SupplyChainPolicy',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    im: () => imDataGet(dueDiligence({
      namespace: 'IMS',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    sci: () => sciDataGet(dueDiligence({
      namespace: 'SCI',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    bpe: () => bpeDataGet(dueDiligence({
      namespace: 'BPE',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
    gm: () => gmDataGet(dueDiligence({
      namespace: 'GM',
      module,
      view: 'scoping',
      version,
      sourceId,
    })),
  };

  const callToGetData = (_doCall = false) => {
    const dKey = dataKey[namespace];
    const nKey = `${module}-${getNkey(namespace)}`;
    const doCall = _doCall ? true : hasKey(allData, dKey) && hasKey(allData[dKey], nKey) ? allData[dKey][nKey]?.data?.datastakeId !== id : true;
    if (doCall) {
      if (isSupported) {
        namespaceGet[namespace]();
        setLanguage(user.language);
      }
    }
  }

  const onStorageUpdate = (e) => {
    const { key, newValue } = e;
    if (key === `${id}-loading` && newValue) {
      setLoading(newValue);
    }
    if (key === `${id}-updated` && newValue) {
      setLoading(true);
      callToGetData();
    }
  };

  useEffect(() => {
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);
  useEffect(() => {
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);

  useEffect(() => {
    callToGetData(true);
  }, [id, namespace, user.language]);

  useEffect(() => {
    if (sProject && sProject !== selectedProject) {
      goToList();
    } else {
      setSProject(selectedProject);
    }
  }, [selectedProject])

  useEffect(() => {
    setLoading(true);
  }, [namespace])

  const prepareForm = (currentView) => {
    const dKey = dataKey[namespace];
    const nKey = `${module}-${currentView}`;

    if (hasKey(allData, dKey) && hasKey(allData[dKey], nKey)) {
      const { form = {}, data = {}, config = {}, linkingForms = {} } = JSON.parse(JSON.stringify(allData[dKey][nKey] || {}));

      if (data.datastakeId === id || id === 'user') {
        if (linkingSubjects.includes(namespace) && moduleWithLinkingSubjects.includes(module)) {
          setForm({
            ...form,
            linking: {
              position: 100,
              excludeFromEdit: true,
              label: t('Linked Subjects'),
              template: 'linkingSubjects',
            },
          });
        } else {
          setForm(form);
        }
        setData(data);
        setGroups(config.groups || {});
        setLinkingForms(linkingForms);
        setViewConfig(allView[viewKey[namespace]] || {});
        setLoading(false);
        setNotFound(false);
      } else if (!data.id) {
        if (mode === 'proxy' && sessionStorage.getItem('proxy_project') !== PROJECTS.myData) {
          sessionStorage.setItem('proxy_project', PROJECTS.myData);
          window.location.reload();
        } else {
          setLoading(false);
          setNotFound(true);
        }
      }
    }
  };

  useEffect(() => {
    if (['ownership-kyc'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [ownershipKycData])

  useEffect(() => {
    if (['esg-assessment'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [esgAssessmentData])

  useEffect(() => {
    if (['mine-profile'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [mineProfileData])

  useEffect(() => {
    if (['application-form'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [applicationFormData])

  useEffect(() => {
    if (['amp'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [ampData])

  useEffect(() => {
    if (['programs'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [programsData])

  useEffect(() => {
    if (['stakeholder', 'scp', 'mine-operators', 'kyc'].includes(namespace)) {
      prepareForm(namespace);
    }
  }, [stakeholderData])

  useEffect(() => {
    if (['location', 'scl', 'village'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [sclData])

  useEffect(() => {
    if (['event', 'incidents', 'corrective-actions', 'testimonials'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [eventData])

  useEffect(() => {
    if (['initiatives', 'victims', 'pictures'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [linkedSubjectsData])

  useEffect(() => {
    if (['documents'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [documentData])

  useEffect(() => {
    if (['lir'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [lirData])

  useEffect(() => {
    if (['project'].includes(namespace)) {
      prepareForm('project');
    }
  }, [projectData])

  useEffect(() => {
    if (['sp'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [spData])

  useEffect(() => {
    if (['im'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [imData])

  useEffect(() => {
    if (['sci'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [sciData])

  useEffect(() => {
    if (['bpe'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [bpeData])

  useEffect(() => {
    if (['gm'].includes(namespace)) {
      prepareForm('scoping');
    }
  }, [gmData])

  const hasKey = (obj, key) => Object.keys(obj || {}).includes(key);
  const goToList = () => {
    const filters = StorageManager.getFilters(module, namespaceAllPath[namespace]);
    const qs = Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&');
    push(
      qs !== '' ? `${`/${mode}/${module}/${namespaceAllPath[namespace]}`}?${qs}` :
        `${`/${mode}/${module}/${namespaceAllPath[namespace]}`}?page=1`
    );
  }

  const getTitleTooltip = () => {
    switch (namespace) {
      case 'incidents':
      case 'corrective-actions':
      case 'testimonials':
        if (data.published) {
          return (viewConfig.title || {})[language] || '';
        }

        return `${Math.round(data.percentageCompletion || 0)}%`;
      case 'ownership-kyc':
        if (data.kycStatus && data.kycStatus !== "registered") {
          return (viewConfig.title || {})[language] || '';
        }

        return `${Math.round(data.kycCompletionPercentage || 0)}%`;
      case 'mine-profile':
        if (data.mineProfileStatus && data.mineProfileStatus !== "registered") {
          return (viewConfig.title || {})[language] || '';
        }

        return `${Math.round(data.mineProfileCompletionPercentage || 0)}%`;
      case 'amp':
      case 'application-form':
        if (data.applicationFormStatus && data.applicationFormStatus !== "registered") {
          return (viewConfig.title || {})[language] || '';
        }

        return `${Math.round(data.ampCompletionPercentage || 0)}%`;
      default:
        return null
    }
  }

  const pageTitle = useMemo(() =>
    renderPageTittle({ namespace, viewConfig, data, language, t, mod: module }),
    [viewConfig, namespace, t, language, data, module]);

  const extraLinking = useMemo(() => {
    if ((namespace === 'village' || (data || {}).category === 'village')
      && match.params.group === 'location') {
      const categoryOptions = form.location ? form.location.category.options : {};

      return [
        {
          namespace: 'village',
          key: 'associatedMiningSites',
          columns: [
            {
              label: 'ID',
              key: 'datastakeId',
            },
            {
              label: 'Location Name',
              key: 'locationName',
            },
            {
              label: 'Category',
              key: 'category',
              options: categoryOptions,
            }
          ],
          component: 'TABLE',
          title: 'Main associated mine sites',
        },
      ]
    };
    return null;
  }, [namespace, match, data]);

  const breadCrumbs = useMemo(() => {
    return renderBreadCrumbs({
      isAnalysis,
      view: namespace,
      t,
      goTo: push,
      isView: true,
      sourceId,
      mod: module,
      id,
    })
  }, [namespace, t, push, sourceId, data, isAnalysis, id])

  const supportText = useMemo(() => {
    switch (namespace) {
      case 'application-form':
        return t('All required sections must be completed before the application can be submitted.');
      default:
        return ''
    }
  }, [namespace, t]);


  return !isSupported || notFound ? <Loading /> : (!loading ? (
    <Style className={formatClassname([(isAnalysis || ((namespace === 'location' || namespace === 'village') && groupForm.template === 'risk')) && 'is-analysis'])}>
      <Header
        title={pageTitle}
        breadcrumbs={breadCrumbs}
        titleTooltip={getTitleTooltip()}
        // onBack={mode === 'proxy' ? null : goBack}
        supportText={supportText}
        tags={headerTags}
        actionButtons={pageActions}
        extraButtons={extraPageActions}
        onDownload={() => { }}
      />
      <div className="view-content">
        <Navigation
          mod={module}
          data={data} match={match} form={form} group={group} subsection={subsection} search={search}></Navigation>
        {groupForm.template ? (
          <Template
            user={user}
            template={groupForm.template}
            namespace={namespace}
            location={{
              locationName: viewConfig.title,
              locationType: (viewConfig.tags || []).find((t) => t.label.en === 'Category'),
            }}
            conf={{
              mod: module,
              group: group,
              form: groupForm,
              data: data[group] ? data[group] : (data || {}),
              allData: data,
              linkingForms: linkingForms || {},
              linkingData: data.linking || {},
              match,
              canEdit: isSupported && canEditAction[namespace]() && selectedProject === PROJECTS.myData,
              mode,
            }}
          />
        ) : (
          <Content
            form={groupForm}
            versionsDatapoints={versionsDatapoints}
            data={data || {}}
            groupConfig={groups || {}}
            linkingData={(data || {}).linking || {}}
            linkingForms={linkingForms || {}}
            ajaxOptions={emptyArr}
            extraLinking={extraLinking}
          />
        )}
      </div>
      {contextHolder}
      {canInviteCustomer && inviteClient && <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t("Invite client")} />}
        open={inviteClient}
        maskClosable={false}
        onClose={() => {
          // ProjectDataGet({ namespace: 'PMEProject', module: 'pme', view: 'project', projectId: id });
          setInviteClient(false);
        }}
        width={CREATE_DRAWER_WIDTH}
        key="customer"
        bodyStyle={{ padding: 0 }}>
        <ProjectCreate
          namespace="Project"
          module="pme"
          view={"customer"}
          showSaveAndNext={false}
          projectId={id}
          info={true}
          edit={true}
          data={data}
          form={form}
          onSubmitted={(type, m) => {
            setInviteClient(false);
          }}
          onCancel={() => setInviteClient(false)}
        />
      </Drawer>}
      <Modal
        title={(
          <ModalHeader
            title={t("Delete subject")}
          />
        )}
        open={deletionVisible}
        onCancel={() => setDeletionVisible(false)}
        onOk={() => {
          setLoading(true);
          namespaceRemove[namespace]({ id: data.id, module, data: { parentId: data.parent || null, deletionReason } }, (type, m) => {
            displayMessage(type, m);
            setDeletionVisible(false);
            setDeletionReason(null);
            push(`/${mode}/${module}/${namespaceAllPath[namespace]}`);
            setLoading(false);
          });
        }}>
        <Select
          {...getPopupContainer()}
          onChange={ev => setDeletionReason(ev)}
          placeholder={t('Please indicate the reason for deleting this subject')}
          style={{ width: '100%' }}>
          <Select.Option value="Duplicate">
            {t('Duplicate. This subject is already identified')}
          </Select.Option>
          <Select.Option value="Error">
            {t('Issue with core data')}
          </Select.Option>
          <Select.Option value="Non-Existent">
            {t('Subject does not exist and was created by mistake')}
          </Select.Option>
          <Select.Option value="Other">
            {t('Other reason')}
          </Select.Option>
        </Select>
      </Modal>
    </Style>
  ) : <Loading />);
}

const mstp = ({
  stakeholder,
  amp,
  programs,
  applicationForm,
  scl,
  authentication,
  events,
  documents,
  lir,
  project,
  sp,
  im,
  sci,
  bpe,
  gm,
  mineProfile,
  ownershipKyc,
  esgAssessment,
  linkedSubjects,
}) => ({
  stakeholder,
  scl,
  amp,
  programs,
  applicationForm,
  authentication,
  events,
  documents,
  lir,
  project,
  sp,
  im,
  sci,
  bpe,
  gm,
  mineProfile,
  ownershipKyc,
  esgAssessment,
  linkedSubjects,
});

export default connect(mstp, actions)(View);
